import request from './request';

export function getNew(id) {
    return request('get', `/apiv2/news/${id}`, {});
}

export function newsRelated(id){
  return request('get', `/apiv2/news/${id}/news_related`, {});
}